import React from 'react';
import styles from '../Operations.module.css';

interface EEYCComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

const EEYC: EEYCComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>
      <div className={styles.sectionContent}>
        5 or more surveys in the current year (must have at least 5 completed surveys for data to populate).
      </div>

      <div className={styles.sectionTitle}>
        Drill Down
      </div>
      <div className={styles.sectionContent}>
        To drill down into data login to the{' '}
        <a
          href="https://acehardware.medallia.com/sso/acehardware/idpSelect.do"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          Helpful Experience/Medallia Dashboard
        </a>.
        <br /><br />
        Use the new Dashboard to take a deeper dive into your EE Surveys. 
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>
      <div className={styles.sectionContent}>
        <ol style={{ marginTop: 0, paddingLeft: '2rem' }}>
          <li>Review your survey results and Action Plan that has been generated and sent to your email address.</li>
          <li>Work through the Action plan and take related Ace Learning Place Employee Engagement Training.</li>
        </ol>
      </div>
    </div>
  );
};

EEYC.title = 'Employee Engagement - Completed Surveys';
EEYC.actionTitle = 'Review Medallia Dashboard';
EEYC.actionHyperlink = 'https://acehardware.medallia.com/sso/acehardware';
export default EEYC;
